<template>
	<FormulateInput
		class="col-12 px-0 mb-3"
		type="checkbox"
		name="agreeRegulationsClubs"
		data-action="panels-agree-regulations-clubs"
		:validation="`${required ? 'required' : ''}`"
		:validation-messages="{
			'required': 'обязательно к заполнению',
		}"
	>
		<template #label="{ id }">
			<label :for="id" class="ml-2">
				Подтверждаю, что я ознакомился(-лась), принимаю и соглашаюсь с Правилами, Ценностями Сообщества выпускников Сколково, указанными в Приложении к <a href="https://ftp.skolkovo.ru/web_team/media/Regulations_Clubs.pdf">Положению об официальных клубах выпускников и/или слушателей  Московской школы управления «СКОЛКОВО»</a>, утвержденному Приказом Ректора Московской школы управления «СКОЛКОВО» от 25.07.2024 г. №4-Ord-136A/24
			</label>
		</template>
	</FormulateInput>
</template>

<script>
export default {
	name: 'AgreeRegulationsClubsInput',
	props: {
		required: { type: Boolean, default: false },
	},
};
</script>
